import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';

import { recursosHumanosModuleName } from "../../shared/data.service";
import { motoristasModuleName, motoristasStorage } from "../shared/data.service";
import { Motorista } from "../shared/motorista.model";
import { MotoristaNavigationService } from "../shared/motorista-navigation.service";
import { MotoristaApiService } from "../shared/motorista-api.service";
import { FuncionarioApiService } from "../../funcionarios/funcionario-api.service";
import { UtilService } from "../../../shared/services/util.service";
import { editRoute, newRoute } from "../../../shared/services/data.service";
import { Funcionario } from "../../funcionarios/funcionario.model";
import { FuncionarioService } from "../../funcionarios/funcionario.service";
import { CnhValidator } from "../../../shared/validators/cnh.validation";
import { AutoCompleteService } from "../../../shared/components/autocomplete/autocomplete.service";
import { MotoristaService } from "../shared/motorista.service";
import { pessoasStorage } from "../../pessoas/shared/data.service";
import { PessoaNavigationService } from "../../pessoas/shared/pessoa-navigation.service";
import { funcionariosQueryComPessoa } from "../../funcionarios/data.service";
import { CategoriaCnhApiService } from "../../../bens/cnh/categorias-cnh/shared/categoria-cnh-api.service";
import { CategoriaCnh } from "../../../bens/cnh/categorias-cnh/shared/categoria-cnh.model";
import {AttService} from "../../../shared/services/att.service";
import {PessoaApiService} from "../../pessoas/shared/pessoa-api.service";

@Component({
    template: require('./motorista-form.component.html'),
    styles: [require('./motorista-form.component.css')]
})
export class MotoristaFormComponent implements OnInit {
    recursosHumanosModule: any = recursosHumanosModuleName;
    motoristasModule: any = motoristasModuleName;
    formObject: any = new Motorista();
    funcionarioObject: any = new Funcionario();
    categoriaCnhObject: any = new CategoriaCnh();
    actionTitle: string;
    submitted: boolean = false;
    btnSaveDisabled: boolean = false;
    imageUrl: string = '';
    funcionarioSelectId: string = 'funcionario';
    funcionarioQuery: string = funcionariosQueryComPessoa;
    categoriasCnhList: any[] = [];

    form: FormGroup;
    cnh = new FormControl('', Validators.compose([Validators.required, CnhValidator.cnhFormat]));
    ativo = new FormControl('');
    dataDemissao = new FormControl('');
    dataAdmissao = new FormControl('');
    lentesObrigatorias = new FormControl('');
    observacoes = new FormControl('');
    primeiraHabilitacao = new FormControl('');
    validadeHabilitacao = new FormControl('');
    vinculoEmpregaticio = new FormControl('');
    categoriaCnh = new FormControl('');
    matricula = new FormControl('');
    funcionario = new FormControl('', Validators.required);

    private returnToOtherForm: boolean = false;
    private otherForm: string;
    private responseMotorista: any;
    private imageToSave: any = {};

    constructor(
        private _route: ActivatedRoute,
        private _motoristaNavigationService: MotoristaNavigationService,
        private _motoristaApiService: MotoristaApiService,
        private _motoristaService: MotoristaService,
        private _funcionarioApiService: FuncionarioApiService,
        private _funcionarioService: FuncionarioService,
        private _pessoaNavigationService: PessoaNavigationService,
        private _pessoaApiService: PessoaApiService,
        private _utilService: UtilService,
        private _autocompleteService: AutoCompleteService,
        private _categoriaCnhApiService: CategoriaCnhApiService,
        private _attService: AttService,
        private _fb: FormBuilder
    ) {
        this.form = _fb.group({
            ativo: this.ativo,
            dataDemissao: this.dataDemissao,
            dataAdmissao: this.dataAdmissao,
            matricula: this.matricula,
            cnh: this.cnh,
            lentesObrigatorias: this.lentesObrigatorias,
            observacoes: this.observacoes,
            primeiraHabilitacao: this.primeiraHabilitacao,
            validadeHabilitacao: this.validadeHabilitacao,
            vinculoEmpregaticio: this.vinculoEmpregaticio,
            categoriaCnh: this.categoriaCnh,
            funcionario: this.funcionario
        });
    }

    ngOnInit() {
        this.setImagePattern();
        this.getCategoriasCnh();
        this.isNewAutoComplete();
    }

    clickGoToList() {
        this.goToList();
    }

    clickCancel() {
        this.toLeaveHere();
    }

    changeFile(e: any) {
        let target = e.target;

        let isValid = this._attService.isValidAttachment(target, true, false);
        if (isValid) {
            this._attService.loadFile(target.files[0], this.responseSuccessS3File);
        }
    }

    clickRemoverImagem() {
        var onDelete = (function() {
            this.onDeleteFile();
        }.bind(this));

        this._utilService.swalMessageDelete(onDelete);
    }

    onSubmit(evt: any) {
        this.submitted = true;
        if(evt.valid) {
            this.btnSaveDisabled = true;
            var object:Motorista = this._utilService.cloneObject(this.formObject);
            var validade_date:any;

            if (this.funcionarioObject.id) {
                object.funcionarioId = this.funcionarioObject.id;
            } else {
                this.btnSaveDisabled = false;
                return false;
            }

            validade_date = document.getElementById('validade_habilitacao');
            if (validade_date.value) {
                object.validadeHabilitacao = this._utilService.convertStringToDate(validade_date.value);
            } else {
                object.validadeHabilitacao = null;
            }

            validade_date = document.getElementById('primeira_habilitacao');
            if (validade_date.value) {
                object.primeiraHabilitacao = this._utilService.convertStringToDate(validade_date.value);
            } else {
                object.primeiraHabilitacao = null;
            }

            validade_date = document.getElementById('demissao');
            if (validade_date.value) {
                object.dataDemissao = this._utilService.convertStringToDate(validade_date.value);
            } else {
                object.dataDemissao = null;
            }

            validade_date = document.getElementById('admissao');
            if (validade_date.value) {
                object.dataAdmissao = this._utilService.convertStringToDate(validade_date.value);
            } else {
                object.dataAdmissao = null;
            }

            if (this.categoriaCnhObject.id) {
                object.categoriaCnhId = this.categoriaCnhObject.id;
            } else{
                object.categoriaCnhId = null;
            }

            if (object.id) {
                this.onEditMotorista(object);
            } else {
                this.onAddMotorista(object);
            }
        }
    }

    getFuncionariosObject(object: any) {
        if(object.novo) {
            var thisFormObject: any = this.formObject;
            thisFormObject.funcionario = this.funcionarioObject;

            this._motoristaService.setSessionStorage(thisFormObject);

            var toOtherFormObject: any = {
                nome: object.text,
                isFuncionario: true,
                form: motoristasStorage
            };
            this._autocompleteService.setSessionStorage(toOtherFormObject, pessoasStorage);
            this._pessoaNavigationService.goToNew();
        } else {
            this.funcionarioObject = object;
            this._utilService.setSelectOnFormControl(this.form, 'funcionario', object);
        }
    }

    funcionarioTemplateResult = (function(state: any) {
        var template: any = this._funcionarioService.templateResult(state, true);
        return template;
    }.bind(this));

    keyupCnh(){
        this.formObject.cnh = this.formObject.cnh.replace(/\D/g, '');
    }

    private onAddMotorista(object: Motorista) {
        this._motoristaApiService.onPost(object, this.onDone);
    }

    private onEditMotorista(object: Motorista) {
        this._motoristaApiService.onPut(object, this.onDone);
    }

    private onDone = (function (Response: any) {
        if (!Response.error)  {
            if (this.formObject.id) {
                this._utilService.swalMessageEditSuccess();
            } else {
                this._utilService.swalMessageAddSuccess();
                if (this.imageToSave.ativo) {
                    let des: string = '';
                    if (this.funcionarioObject.pessoa) {
                        des = this.funcionarioObject.pessoa.nome;
                    }
                    this.imageToSave.descricao = des;
                    this.imageToSave.pessoaId = this.funcionarioObject.pessoaId;
                    this.onSaveFile();
                }
            }

            this.toLeaveHere();
        } else {
            this.btnSaveDisabled = false;
            this._utilService.swalMessageWarningCustom(Response.error);
        }
    }.bind(this));

    private getObject(id: number) {
        var onDone = (function(Response: any) {
            if (!Response.error)  {
                this.formObject = Response;
                this.setModelToForm();

            } else {
                this._utilService.swalMessageWarningCustom('Nenhum motorista encontrado com este id.');
                this.toLeaveHere();
            }
        }.bind(this));

        this._motoristaApiService.onGetById(id, onDone);
    }

    private getImage(id: number) {
        var onDone = (function(Response: any) {
            if (!Response.error)  {
                if (Response.length) {
                    this.imageUrl = Response[0].url;
                    this.imageToSave = Response[0];
                }
            }
        }.bind(this));

        this._pessoaApiService.onGetByPessoa(id, onDone);
    }

    private setModelToForm() {
        if (this.formObject.validadeHabilitacao) {
            if (this.formObject.validadeHabilitacao.indexOf("/") === -1) {
                this.formObject.validadeHabilitacao = this._utilService.convertDateToString(this.formObject.validadeHabilitacao);
            }
        }

        if (this.formObject.primeiraHabilitacao) {
            if (this.formObject.primeiraHabilitacao.indexOf("/") === -1) {
                this.formObject.primeiraHabilitacao = this._utilService.convertDateToString(this.formObject.primeiraHabilitacao);
            }
        }

        if (this.formObject.dataDemissao) {
            if (this.formObject.dataDemissao.indexOf("/") === -1) {
                this.formObject.dataDemissao = this._utilService.convertDateToString(this.formObject.dataDemissao);
            }
        }

        if (this.formObject.dataAdmissao) {
            if (this.formObject.dataAdmissao.indexOf("/") === -1) {
                this.formObject.dataAdmissao = this._utilService.convertDateToString(this.formObject.dataAdmissao);
            }
        }

        if (this.formObject.funcionario) {
            this.funcionarioObject = this._utilService.cloneObject(this.formObject.funcionario);
            delete this.formObject['funcionario'];

            if (this.funcionarioObject.pessoa) {
                this.getImage(this.funcionarioObject.pessoaId);
                var selectObject:any = {text: this.funcionarioObject.pessoa.nome, id: this.funcionarioObject.id};

                this._autocompleteService.createOptionOnSelect2(this.funcionarioSelectId, selectObject);
                this._autocompleteService.setValueOnSelect2(selectObject.id, this.funcionarioSelectId);
                this._utilService.setSelectOnFormControl(this.form, 'funcionario', this.funcionarioObject);
            }
        }

        if (this.formObject.categoriaCnh) {
            this.categoriaCnhObject = this._utilService.cloneObject(this.formObject.categoriaCnh);
            delete this.formObject['categoriaCnh'];
            this.setCategoriaCnh();
        }
    }

    private toLeaveHere() {
        if (this.returnToOtherForm) {
            this._motoristaService.returnToOtherForm(this.otherForm, this.responseMotorista);
        } else {
            this.goToList();
        }
    }

    private goToList() {
        this._motoristaNavigationService.goToList();
    }

    private testSession() {
        var id: number;
        var session: any = this._motoristaService.getSessionStorage();
        this._motoristaService.clearSessionStorage();

        if (session) {
            this.formObject = session;
            id = session.id;
            this.setModelToForm();
        } else {
            id = +this._route.snapshot.params['id'];
            if (id) {
                this.setEditNormal(id);
            } else {
                this.setNewNormal();
            }
        }

        this.setActionTitle(id);
    }

    private setActionTitle(id: any) {
        if (id) {
            this.actionTitle = editRoute;
        } else {
            this.actionTitle = newRoute;
        }
    }

    private setEditNormal(id: number) {
        this.getObject(id);
    }

    private setNewNormal() {
        //se tiver alguma configuração inicial de um cadastro novo
    }

    private setEditSession() {
        //qndo retornou para continuar a edição
    }

    private setNewSession() {
        //qndo retornou para continuar o cadastro
    }

    private isNewAutoComplete() {
        var newAutoComplete: any = this._autocompleteService.getSessionStorage(motoristasStorage);
        if (newAutoComplete) {
            this.returnToOtherForm = true;
            this.otherForm = newAutoComplete.form;
            this.funcionarioObject = {pessoa: newAutoComplete.nome};

            this.setActionTitle(this.formObject.id);
        } else {
            //retornando de um cadastro
            this.testSession();
        }
    }

    private getCategoriasCnh() {
        var onDone = (function(Response: any) {
            if (!Response.error)  {
                this.categoriasCnhList = Response;
                this.categoriasCnhList.unshift({id: null, categoria: '— Selecione —'});
                this.setCategoriaCnh();
            }
        }.bind(this));

        this._categoriaCnhApiService.onGetAll(onDone);
    }

    private setCategoriaCnh() {
        var x: any, lenX: any,
            t: number = this.categoriaCnhObject.id;

        if (!t) {
            t = this.categoriasCnhList[0].id;
        }
        for (x = 0, lenX = this.categoriasCnhList.length; x < lenX; x++) {
            if (this.categoriasCnhList[x].id === t) {
                this.categoriaCnhObject = this.categoriasCnhList[x];
                break;
            }
        }
    }

    private responseSuccessS3File = (function(response: any) {
        let description: string = '',
            pessoaId: number = null;
        if (this.funcionarioObject.pessoa) {
            description = this.funcionarioObject.pessoa.nome;
            pessoaId = this.funcionarioObject.pessoaId;
        }

        let newAtt: any = {
            descricao: description,
            url: response.url,
            formato: response.fileExtension,
            data: new Date(),
            ativo: true,
            pessoaId: pessoaId
        };

        if (this.imageToSave.id) {
            newAtt.id = this.imageToSave.id;
        }

        this.imageUrl = response.url;
        this.imageToSave = newAtt;
        if (this.formObject.id) {
            this.onSaveFile();
        }
    }.bind(this));

    private onSaveFile() {
        let onDone = (function(Response: any) {
            if (!Response.error)  {
                if (this.formObject.id) {
                    this._utilService.swalMessageAddSuccess();
                }
            } else {
                this._utilService.swalMessageWarningCustom(Response.error);
            }
        }.bind(this));

        if (this.imageToSave.id) {
            this._pessoaApiService.onPutImage(this.imageToSave, onDone);
        } else {
            this._pessoaApiService.onPostImage(this.imageToSave, onDone);
        }
    }

    private onDeleteFile() {
        let onDone = (function(Response: any) {
            if (!Response.error)  {
                this.setImagePattern();
                this._utilService.swalMessageDeleteSuccess();
            } else {
                this._utilService.swalMessageWarningCustom(Response.error);
            }
        }.bind(this));

        if (this.imageToSave.id) {
            this._pessoaApiService.onDeleteImage(this.imageToSave.id, onDone);
        } else {
            this.imageToSave = {};
            this.setImagePattern();
            this._utilService.swalMessageDeleteSuccess();
        }
    }

    private setImagePattern() {
        this.imageUrl = '';
    }
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/recursos-humanos/motoristas/motorista-form/motorista-form.component.ts
 **/